module.exports = __webpack_public_path__ + "static/media/comercial.35b091a9.svg";